import { 
  Lock, 
  Scale, 
  Building, 
  Zap 
} from "lucide-react";

const benefits = [
  { icon: Lock, text: "Cryptographic Evidence" },
  { icon: Scale, text: "Legal Enforceability" },
  { icon: Building, text: "Enterprise Security" },
  { icon: Zap, text: "5-Minute Setup" }
];

const KeyBenefits = () => {
  return (
    <section className="py-16 bg-background/50 relative">
      <div className="container mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="flex items-center gap-3 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="p-2 bg-primary/10 rounded-lg">
                <benefit.icon className="h-5 w-5 text-primary" />
              </div>
              <span className="text-foreground font-medium">{benefit.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyBenefits;